var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-content"},_vm._l((this.tabs),function(tab){return _c('div',{key:tab.id + '-component',staticStyle:{"position":"relative","top":"0px"}},[_c('transition',{attrs:{"name":"fade"}},[(tab.isActive)?_c(tab.component,_vm._b({tag:"component"},'component',tab.props,false)):_vm._e()],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }